export const /** @type {?} */ CONFIRMATION_SENT = 'ConfirmationSent';
